<template>
  <div class="outer">
    <div class="buttons">
      <portal-target name="histBack"></portal-target>
      <div class="btnContainer" :style="{ fontSize: fonts.font12 + 'px' }">.</div>
    </div>
    <!-- <div class="quicken2005">
      <portal-target name="quickenPortal"></portal-target>
      <div class="btnContainer" :style="{ fontSize: fonts.font12 + 'px' }">.</div>
    </div> -->
    <div id="histPage">
      <div v-if="history.type === 'S'">    <!-- Share History -->
        <shHist id="shareHist"></shHist>
      </div>
      <div v-if="history.type === 'D'">    <!-- Draft History -->
        <shHist id="draftHist"></shHist>
      </div>
      <div v-if="history.type === 'L'">    <!-- Loan History -->
        <lnHist id="loanHist"></lnHist>
      </div>
    </div>
    <!-- ============================================ -->
    <modal name="quicken2005Modal"
           :width="300"
           :height="340"
           :clickToClose="false">
      <div class="geanBox">
        <div class="geanTitle">Quicken 2005+ Export</div>
        <p class="geanDescArea" v-html="quickenDescArea"></p>
        <div class="geanQanLabel">Quicken Account Name</div>
        <b-form-input autocomplete="nope"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="false"
                      class="acctInput"
                      aria-label="Enter Quicken Account Name"
                      type="text"
                      v-model="quickenAcctName"
                      required
                      placeholder="Enter Quicken Account Name">
        </b-form-input>

        <b-button-group class="geanBtnGroup">
          <button class="geanOk"
                  @click="geanExportClick">Export</button>
          <button class="geanCancel"
                  @click="geanCancelClick">Cancel</button>
          <button class="geanHelp"
                  @click="geanHelpClick">Help</button>
        </b-button-group>
      </div>
    </modal>
    <!-- ============================================ -->
    <modal name="quicken2005HelpModal"
           :width="300"
           :height="450"
           :clickToClose="false">
      <div class="geanHelpBox">
        <div class="geanTitle">Quicken 2005+ Import Help</div>
        <p id="helpPrint" class="geanDescArea" v-html="quickenHelpArea"></p>
        <b-button-group class="geanHelpBtnGroup">
          <button class="geanOk"
                  @click="geanCloseHelp">Close</button>
          <button class="geanHelp"
                  @click="geanPrintHelp">Print</button>
        </b-button-group>
      </div>
    </modal>
    <!-- ============================================ -->
    <portal to="histBack">
      <div id="topButtons">
        <b-button-group class="btnGroup">
          <!-- <button class="btnClass" id="btnPrint"
                  @click="goPrint">Print</button> -->
          <button class="btnClass" id="btnBack"
                  @click="goBack">Back</button>
          <!-- <button class="btnClass"
                  @click="goExport">Export</button> -->
          <button class="btnClass"
                  @click="goSearch">Search</button>
        </b-button-group>

        <!-- [159] Export History -->
        <b-dropdown
          v-if="ssListLength > 0"
          class="dropdown-saved"
          text="Saved Search"
          size="sm"
          right
          no-flip
          variant="primary"
          >
          <b-dropdown-text style="width: 250px;" class="dropHead">
            Select Saved Search
          </b-dropdown-text>
          <div v-for="ss in ssList" :key="ss.key">
            <b-dropdown-item-button
              class="dropItem"
              @click="clickedSS(ss)">
              {{ ss.desc }}
            </b-dropdown-item-button>
          </div>
          <div v-if="ssListLength === 1">
            <b-dropdown-item-button
            class="dropItem"
            @click="goSearch">
              Add searches in "Search"
            </b-dropdown-item-button>
          </div>
        </b-dropdown>

        <b-dropdown
          v-if="showExport"
          class="dropdown-export"
          text="Export"
          size="sm"
          right
          no-flip
          variant="primary"
        >
          <b-dropdown-text style="width: 250px;" class="dropHead">
            Select Export Type
          </b-dropdown-text>
          <div v-for="ex in exList" :key="ex.key">
            <b-dropdown-item-button
              class="dropItem"
              @click="clickedEX(ex)">
              {{ ex.desc }}
            </b-dropdown-item-button>
          </div>
        </b-dropdown>

      </div>
      <div v-if="history.type === 'S' && shareCount >= 0"
           class="trCount"
           :style="{ fontSize: fonts.font12 + 'px' }">
        Share Transaction Count: {{shareCount}}
      </div>
      <div v-if="history.type === 'D' && shareCount >= 0"
           class="trCount"
           :style="{ fontSize: fonts.font12 + 'px' }">
        Draft Transaction Count: {{shareCount}}
      </div>
      <div v-if="history.type === 'L' && loanCount >= 0"
           class="trCount"
           :style="{ fontSize: fonts.font12 + 'px' }">
        Loan Transaction Count: {{loanCount}}
      </div>
      <div v-if="this.history.searchDesc.length > 0"
           :style="{ fontSize: fonts.font16 + 'px' }">
        Saved-Search: {{this.history.searchDesc}}
      </div>
      <!-- <b-button
        @click="goBack"
        :style="{ fontSize: fonts.font14 + 'px' }"
        class="btnBack">Back</b-button> -->
    </portal>
  </div>
</template>

<script>
// import jsPDF from 'jspdf';
import shHist from './z-shareHistory';
import lnHist from './z-loanHistory';
import utl from '../myUtils';

export default {
  components: {
    shHist,
    lnHist,
  },
  name: 'history',
  data() {
    return {
      exList: [
      ],
      showExport: true,
      quickenAcctName: '',
      // show2005Name: false,
    };
  },
  history() {
    this.$forceUpdate();
  },
  computed: {
    quickenDescArea() {
      return this.$store.getters.getQuickenDescArea;
    },
    quickenHelpArea() {
      return this.$store.getters.getQuickenHelpArea;
    },
    ssListLength() {
      return Object.keys(this.ssList).length;
    },
    ssList() {
      return this.$store.getters.getSavedSearchList;
    },
    trHigh() {
      return this.$store.getters.getTrHigh;
    },
    quickRange() {
      return this.$store.getters.getSearchRange;
    },
    shareCount() {
      return this.$store.getters.getShareTranCount;
    },
    loanCount() {
      return this.$store.getters.getLoanTranCount;
    },
    history() {
      return this.$store.getters.getHistory;
    },
    histShares() {
      return this.$store.getters.getHistShares;
    },
    histLoans() {
      return this.$store.getters.getHistLoans;
    },
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    shareHead() {
      return `${this.member.acct}-${this.history.desc}`;
    },
    loanHead() {
      return `${this.member.acct} Note # ${this.history.note}`;
    },
  },
  /*
  const pdfName = 'test';
  const doc = new jsPDF();
  doc.text('Hello World', 10, 10); // horz,vert
  doc.save(`${pdfName}.pdf`);
  */
  methods: {
    geanExportClick() {
      this.$modal.hide('quicken2005Modal');
      const ex = [];
      ex.type = 14;
      this.clickedEX(ex);
    },
    geanCancelClick() {
      this.$modal.hide('quicken2005Modal');
    },
    geanHelpClick() {
      this.$modal.hide('quicken2005Modal'); // Hide the main box
      this.$modal.show('quicken2005HelpModal');
    },
    geanCloseHelp() {
      this.$modal.hide('quicken2005HelpModal');
      this.$modal.show('quicken2005Modal'); // Show the main box again
    },
    geanPrintHelp() {
      this.$htmlToPaper('helpPrint');
    },
    goPrint() {
      this.$htmlToPaper('histPage');
    },
    goBack() {
      // utl.diag('Clicked Back');
      window.history.back();
    },
    goSearch() {
      // utl.diag('Clicked Search');
      this.$store.commit('setPageIndex', 5);
      //
    },
    clickedEX(ex) { // [159]
      let type = ex.type; // Need to reassign so we can change later (14 becomes 4)
      // utl.diag(`Clicked Export - Type = ${type}`);
      if (type > 99) {
        return; // Ignore "more coming soon"
      }

      if (type === 4) { // Quicken 2005 needs to ask for Acct Name
        this.$modal.show('quicken2005Modal');
        // this.show2005Name = true;
        return;
      }

      if (type === 14) { // Acct Name Box Click
        type = 4; // Change back to read export type
      }

      const ahInfo = {};
      ahInfo.cun = this.cun;
      ahInfo.acct = this.member.acct;
      ahInfo.type = this.history.type;
      ahInfo.share = this.history.share;
      ahInfo.maxTr = this.trHigh;
      ahInfo.option = type;
      ahInfo.note = this.history.note;
      ahInfo.desc = this.history.desc;
      ahInfo.qName = this.quickenAcctName;
      //
      this.$store.commit('initExport', ahInfo);
    },
    clickedSS(ss) {
      // utl.diag(`Clicked: ${ss.desc} key="${ss.key}"`);
      if (ss.key === 'svs- Top') {
        this.$store.commit('setSearchDesc', ''); // Default - Remove Search Desc
      } else {
        this.$store.commit('setSearchDesc', ss.desc);
      }
      const svInfo = ss.data;
      const ahInfo = {};

      // Common Fields
      ahInfo.cun = this.cun;
      ahInfo.acct = this.member.acct;
      ahInfo.type = this.history.type;
      ahInfo.share = this.history.share;
      ahInfo.quan = svInfo.quan;
      ahInfo.maxTr = this.trHigh;
      ahInfo.option = 0;
      ahInfo.note = this.history.note;

      // Date range
      if (svInfo.dateRange === 'cdr') {
        ahInfo.loDate = svInfo.loDate;
        ahInfo.hiDate = svInfo.hiDate;
      } else {
        const dr = utl.getDateRange(svInfo.dateRange);
        ahInfo.loDate = utl.pakDate(dr.startDate);
        ahInfo.hiDate = utl.pakDate(dr.endDate);
      }

      // Check/Draft range
      if ((svInfo.dollarRange === 'ck') || (svInfo.dollarRange === 'cx')) {
        ahInfo.loDraft = svInfo.loDraft;
        ahInfo.hiDraft = svInfo.hiDraft;
      } else {
        ahInfo.loDraft = 0;
        ahInfo.hiDraft = 0;
      }

      // Dollar Range
      if (svInfo.dollarRange === 'cdr') {
        ahInfo.loAmt = svInfo.loAmount; // Pull saved value
        ahInfo.hiAmt = svInfo.hiAmount; // Pull saved value
      } else {
        ahInfo.loAmt = 0; // Value not saved as part of search
        ahInfo.hiAmt = 0; // Value not saved as part of search
      }
      const rv = utl.customizeDollar(svInfo.dollarRange); // Compute Dollar Range (if applicable)
      if (rv.rangeForm === '1') {
        ahInfo.loAmt = parseInt(utl.stripDollar(rv.minDollar), 10) * 100;
        ahInfo.hiAmt = parseInt(utl.stripDollar(rv.maxDollar), 10) * 100;
      }

      // Search Text
      // utl.diag(svInfo.searchText);
      if (typeof svInfo.searchText !== 'undefined') {
        ahInfo.srch = svInfo.searchText;
      } else {
        ahInfo.srch = '';
      }

      if (svInfo.dollarRange === 'ck') {
        ahInfo.loDraft = svInfo.minCheck;
        ahInfo.hiDraft = svInfo.maxCheck;
      } else {
        ahInfo.loDraft = 0;
        ahInfo.hiDraft = 0;
      }

      // Categories
      const ckBox = utl.unpackSearchOptions(svInfo.cats);
      if (ckBox.dft === true) { ahInfo.chk = 'Y'; } else { ahInfo.chk = 'N'; }
      if (ckBox.ach === true) { ahInfo.ach = 'Y'; } else { ahInfo.ach = 'N'; }
      if (ckBox.pos === true) { ahInfo.pos = 'Y'; } else { ahInfo.pos = 'N'; }
      if (ckBox.atm === true) { ahInfo.atm = 'Y'; } else { ahInfo.atm = 'N'; }
      if (ckBox.xfr === true) { ahInfo.xfr = 'Y'; } else { ahInfo.xfr = 'N'; }
      if (ckBox.fee === true) { ahInfo.fee = 'Y'; } else { ahInfo.fee = 'N'; }
      if (ckBox.pay === true) { ahInfo.pay = 'Y'; } else { ahInfo.pay = 'N'; }
      if (ckBox.adv === true) { ahInfo.adv = 'Y'; } else { ahInfo.adv = 'N'; }
      if (ckBox.oth === true) { ahInfo.oth = 'Y'; } else { ahInfo.oth = 'N'; }
      if (ckBox.noRestrict === false) { ahInfo.restrict = 'Y'; } else { ahInfo.restrict = 'N'; }
      ahInfo.direction = svInfo.direction;
      ahInfo.fill = '';
      ahInfo.desc = this.history.desc;
      this.$store.commit('initHist', ahInfo);
      // window.history.back();
    },
    timeReset() {
      // this.iCount = 0;
      const cuInfo = {};
      cuInfo.cun = this.cun;
      cuInfo.acct = this.member.acct;
      cuInfo.page = this.pgIndex;
      cuInfo.navVer = this.navVer;
      if (this.pgIndex === 1) {
        this.wsSend('c4Refresh', cuInfo);
      } else {
        this.wsSend('c4Reset', cuInfo);
      }
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      // data.ver = this.binVer;
      this.$store.commit('sendObjToServer', data);
    },
  },
  created() {
    // [159] Export History List
    this.exList = [];
    this.exList[0] = { type: 1, desc: 'Comma Separated Values (.csv)' };
    this.exList[1] = { type: 2, desc: 'Text File (.txt)' };
    this.exList[2] = { type: 3, desc: 'Generic QIF Format (.qif)' }; // [176]
    this.exList[3] = { type: 4, desc: 'Quicken 2005+ Format (.qif)' }; // [176]
    // this.exList[3] = { type: 100, desc: 'More Coming Soon' };
    // this.exList[4] = { type: 5, desc: 'Old CSV Format (.csv)' };
    // this.exList[5] = { type: 6, desc: 'Old TXT Format (.txt)' };
  },
};
</script>

<style scoped>
  .outer {
    /* position: relative; */
  }
  .btnContainer {
    margin: 4px;
    color: cyan;
  }
  .buttons {
    position: relative;
    width: 100%;
    border: solid 1px black;
  }
  #topButtons {
    position: relative;
    display: inline-block;
  }
  .btnGroup {
    position: relative;
    display: inline-block;
    top: 0px;
    left: 0px;
    color: black;
    font-weight: bold;
    padding: 0px 0px;
    z-index: 100;
  }
  .btnClass {
    position: relative;
    /* width: 60px;*/
    background: blue;
    color: white;
    font-weight: bold;
    font-size: 18px;
    padding: 0px 2px 0px 2px;
    margin-top: 4px;
    border: solid 2px black;
  }
  .quickRange {
    position: relative;
    display: inline-block;
  }
  .btnQuick {
    text-align: center;
    width: 160px;
    background: blue;
    color: white;
    font-weight: bold;
    font-size: 18px;
    padding: 0px 2px 0px 2px;
    margin-top: 4px;
    border: solid 2px black;
  }
  .dropdown-quick {
    position: absolute;
    top: 5px;
    left: 126px;
    background-color: white;
    height: 29px;
    width: 34px;
    padding: 0px;
    margin: 0px;
    border: solid 1px black;
    z-index: 200;
  }
  .dropdown-saved {
    position: relative;
    height: 31px;
    background-color: white;
    margin-top: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
    border: solid 1px black;
    z-index: 200;
  }

  .dropdown-export {
    position: relative;
    height: 31px;
    background-color: white;
    margin-top: 5px;
    padding-top: 0px;
    padding-bottom: 0px;
    border: solid 1px black;
    z-index: 200;
  }
  .disabledButton {
    position: relative;
    /* width: 60px;*/
    background: #909090;
    color: #d0d0d0;
    font-weight: bold;
    font-size: 18px;
    padding: 0px 2px 0px 2px;
    margin-top: 4px;
    border: solid 2px black;
    cursor: not-allowed;
  }
  #btnBack {
    background-color: red;
    color: black;
    font-size: 18px;
  }

  .trCount {
    position: absolute;
    bottom: 0px;
    left: 4px;
    margin: 0px;
    padding: 0px;
  }
  .dropHead { /* Account Header in drop-down */
    background-color: blue;
    color: white;
    font-weight: bold;
  }
  .dropItem { /* Account Item in drop-down */
    padding-left: 20px;
    background-color: white;
    color: black;
    font-weight: bold;
  }
  .geanBox {
    /* width: 300px; */
    height: 340px;
    border: solid 2px black;
    /*
    position: fixed;
    top: 130px;
    left: 20px;
    width: 300px;
    height: 340px;
    background: white;
    z-index: 900; */
  }
  .geanTitle {
    background-color: blue;
    color: white;
    font-weight: bold;
    font-size: 20px;
    margin: auto;
    text-align: center;
  }
  .geanDescArea {
    font-size: 12px;
    padding-left: 4px;
  }
  .geanQanLabel {
    width: 100%;
    margin: auto;
    text-align: center;
    /* border: solid 1px red; */
  }
  .geanBtnGroup {
    height: 30px;
    width: 100%;
    margin-top: 10px;
    /* border: solid 1px red; */
  }
  .geanOk {
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: lightgreen;
    font-weight: bold;
  }
  .geanCancel {
    width: 120px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: red;
    font-weight: bold;
  }
  .geanHelpBox {
    /* width: 300px; */
    height: 450px;
    border: solid 2px black;
  }
  .geanHelpBtnGroup {
    height: 40px;
    left: 30px;
    margin: auto;
    align-content: center;
    align-items: center;
    /* border: solid 5px red; */
  }
  .geanHelp {
    width: 100px;
    margin-left: 4px;
    margin-right: 4px;
    background-color: cyan;
    color: black;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/p04-history.vue